import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import FraudEngineFramework from "../FraudEngine/FraudEngine";
import { RoiList } from "./AiStudioFramework/Roi";
import { RetailList } from "./AiStudioFramework/Retail";
import { PricingList } from "./AiStudioFramework/Pricing";
import { FraudList } from "./AiStudioFramework/Fraud";
import AIStudioFramework from "./AiStudioFramework/AiStudioFramework";
const AIPRODUCTS_TABS = [
  {
    tabIndex: 0,
    tabId: "studio",
    tabName: "AI Studio Retail",
  },
  // {
  //   tabIndex: 0,
  //   tabId: "Fraud",
  //   tabName: "Fraud Engine",
  // }
];

const AiStudioFramework = (): JSX.Element => {
  const [aiProductsTabs, setAiProductsTabs] = useState(AIPRODUCTS_TABS);
  const [searchParams, setSearchParams] = useSearchParams({ tabIndex: "0" });

  const handleTabChange = (tabId: number) => {
    setSearchParams((params) => {
      params.set("tabIndex", JSON.stringify(tabId));
      return params;
    });
  };
  const tabIndex = searchParams.get("tabIndex");
  const parsedTabIndex = tabIndex ? JSON.parse(tabIndex) : 0;

  return (
    <div className="main-container podcasts">
      <div className="podcasts-tab">
        {aiProductsTabs.map((tab, index) => {
          const { tabIndex, tabId, tabName } = tab;

          return (
            <div
              key={tabId}
              tabIndex={index}
              className={`item ${tabIndex === parsedTabIndex ? "active" : ""}`}
              onClick={() => handleTabChange(tabIndex)}
            >
              {tabName}
            </div>
          );
        })}
      </div>
      <>
        {parsedTabIndex === 0 && <AIStudioFramework />}
        {/* {parsedTabIndex === 1 && <FraudEngineFramework />}  */}
      </>
    </div>
  );
};

export default AiStudioFramework;
